import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import GenerateCustomGuidCommand from "./generatecustomguidcommand";

export default class GenerateCustomGuidEditing extends Plugin {
    init() {
        const editor = this.editor;
        editor.commands.add(
            "generatecustomguid",
            new GenerateCustomGuidCommand(editor)
        );
    }
}
